export const publicVersion = "2.8.1-2-g457695c9-2026-05-20T18-04-48Z";